import { Region } from '@coveo/platform-client';
import { sanitizeRegion } from '../Sanitization.js';
import { URLConstant } from '../constants/URLConstant.js';
var placeholder = '{region}';
var injectRegion = function injectRegion(url, region, isOriginUs) {
    var _ref;
    var endpointRegion = region === Region.US && !isOriginUs ? '' : "-".concat(sanitizeRegion(region));
    var matcher = new RegExp(placeholder, 'g');
    return (_ref = url === null || url === void 0 ? void 0 : url.replace(matcher, endpointRegion)) !== null && _ref !== void 0 ? _ref : '';
};
var extractRegion = function extractRegion(url) {
    var _window = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : window;
    var allowedRegions = Object.freeze(Object.values(Region));
    var parameters = new URLSearchParams(_window.location.search);
    // Looking for injected region in the querystring parameter &region=theRegion
    // If the region is valid and includes a region from @coveord/platform-client Region enum, we return it
    var injectedRegion = sanitizeRegion(parameters.get('region'));
    if (injectedRegion && allowedRegions.includes(injectedRegion)) {
        return injectedRegion;
    }
    // Extracting the region from the url hostname
    for(var i = 0; i < URLConstant.APPLICATION_HOST_ROOTS_USED_WITH_REGION.length; i++){
        var EXTRACT_REGION = new RegExp("".concat(URLConstant.APPLICATION_HOST_ROOTS_USED_WITH_REGION[i], "-(\\w+)\\.cloud\\.coveo\\.com")); // extracts "eu" from "platform-eu.cloud.coveo.com"
        var matches = EXTRACT_REGION.exec(url);
        if ((matches === null || matches === void 0 ? void 0 : matches[1]) && allowedRegions.includes(matches[1])) {
            return matches[1];
        }
    }
    return Region.US;
};
export var RegionHelper = {
    injectRegion: injectRegion,
    extractRegion: extractRegion,
    placeholder: placeholder
};

//# sourceMappingURL=RegionHelper.js.map